import { clsx } from 'clsx'
import { Image } from 'component/Image'
import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { SelfieStore } from 'store/profile/SelfieStore'
import css from './Photo.module.scss'

type Props = {
  selfie: SelfieStore
  top?: boolean
}

export const Photo = observer(({ selfie, top }: Props) => {
  const { uploading, src, url } = selfie
  const [state, setState] = useState<string | undefined>()

  useEffect(() => {
    if (url) {
      if (state) setState(css.done)
      else setState(css.stable)
    } else if (uploading) {
      setState(css.start)
      const timeout = setTimeout(() => setState(css.slow), 100)
      return () => clearTimeout(timeout)
    } else {
      setState('')
    }
  }, [src, uploading])

  return <Space className={clsx(css.photo, state)} wide tall>
    {src && <Image className={clsx(css.image, top && css.top)} src={src} />}
    <Space className={css.scan} />
  </Space>
})
